module.exports = require('./helpers/bundle-url').getBundleURL('lbB2N') + "peugeotsportsengineered.53a5fdb8.png";